import { Spacer } from '@travelnest/merlin.spacer';
import React from 'react';
import { FormInputCurrency } from '../../../view/components/form/form-input/FormInputCurrency';

export interface ICustomPriceInputProps {
	id: string;
	label?: string;
	value: number | undefined;
	handleChange?: (val: number | undefined) => any;
	errorMessage?: string;
	nights?: number;
	currency?: string;
}

export const CustomPriceInput: React.FC<ICustomPriceInputProps> = (props) => {
	const { handleChange, label, value, nights, currency } = props;

	const onValueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {

		const numericOnlyValue = e.target.value.replace(/\D/g, '');

		const inputNum = parseInt(numericOnlyValue, 10);

		let propagateVal;
		if (numericOnlyValue === '') {
			propagateVal = 0;
		} else {
			if (isNaN(inputNum)) {
				return;
			}

			propagateVal = inputNum;
		}

		if (handleChange) {
			handleChange(propagateVal);
		}
	};

	const showValidationError = value === 0;

	return (
		<>
			<div style={{ color: 'var(--colour-grey)' }}>{label}</div>
			<Spacer spacing="smaller" />
			<FormInputCurrency
				type="text"
				pattern="[0-9]*"
				onChange={onValueChangeHandler}
				value={value}
				showValidationError={showValidationError ? 'true' : 'false'}
				currency={currency} />
			{showValidationError &&
				<>
					<Spacer spacing="smaller" />
					<div style={{ color: 'var(--colour-orange-red)' }}>Set a price for the selected {nights && nights === 1 ? 'night' : 'nights'}</div>
				</>
			}
			<Spacer />
		</>
	);
};
